import React from "react";
import DOMPurify from "dompurify";

const asHTML = (html) => {
  const isBrowser = typeof window !== "undefined";
  if (!isBrowser) return <span dangerouslySetInnerHTML={{ __html: html }}></span>;

  const processedHTML = html?.replaceAll("--", "&shy;");
  const purifiedHTML = DOMPurify.sanitize(processedHTML);
  return <span dangerouslySetInnerHTML={{ __html: purifiedHTML }} />;
};

export default asHTML;
